import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import FindMeetingLocationsResponse from 'owa-calendar-scheduling-service/lib/schema/FindMeetingLocationsResponse';
import LocationSourceType from 'owa-service/lib/contract/LocationSourceType';
import MeetingLocation from 'owa-calendar-scheduling-service/lib/schema/MeetingLocation';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import PostalAddressAttributedValue from 'owa-service/lib/contract/PostalAddressAttributedValue';
import LocationPersonaType from 'owa-calendar-scheduling-service/lib/schema/LocationPersonaType';

/**
 * Convert FindMeetingLocations response object to Location PersonaTypes
 */
export default function meetingLocationResponseToLocationPersonaType(
    findMeetingLocationsResponse: FindMeetingLocationsResponse
): LocationPersonaType[] {
    let personas: LocationPersonaType[] = [];
    if (findMeetingLocationsResponse) {
        if (findMeetingLocationsResponse.MeetingLocations) {
            findMeetingLocationsResponse.MeetingLocations.map((meetingLocation, index) => {
                const locationAddress = meetingLocation.MeetingLocation.Address;
                const coordinates = meetingLocation.MeetingLocation.Coordinates;
                const address: PostalAddressAttributedValue = {
                    Attributions: ['0'],
                    Value: {
                        LocationUri: meetingLocation.MeetingLocation.LocationUri,
                        Street: locationAddress && locationAddress.Street,
                        City: locationAddress && locationAddress.City,
                        State: locationAddress && locationAddress.State,
                        Country: locationAddress && locationAddress.CountryOrRegion,
                        PostalCode: locationAddress && locationAddress.PostalCode,
                        Latitude: coordinates && coordinates.Latitude,
                        Longitude: coordinates && coordinates.Longitude,
                        LocationSource: getOwaLocationSource(meetingLocation.MeetingLocation),
                        Type: 'Business',
                    } as PersonaPostalAddress,
                };

                let availability = meetingLocation.MeetingLocation.Availability;

                // Bug https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/44777
                // Tenant index search is not setting the location UniqueId. This is a client workaround to and delete this code when the bug is fixed
                const locationId = meetingLocation.MeetingLocation.UniqueId
                    ? meetingLocation.MeetingLocation.UniqueId
                    : meetingLocation.MeetingLocation.LocationUri;
                personas.push({
                    PersonaId: {
                        Id: locationId,
                    },
                    DisplayName: meetingLocation.MeetingLocation.DisplayName,
                    PersonaTypeString:
                        meetingLocation.MeetingLocation.EntityType == 'ConferenceRoom'
                            ? 'Room'
                            : 'Place',
                    EmailAddress: {
                        EmailAddress: meetingLocation.MeetingLocation.LocationEmailAddress,
                        Name: meetingLocation.MeetingLocation.DisplayName,
                    } as EmailAddressWrapper,
                    FeedbackId: locationId,
                    RelevanceHint: meetingLocation.RelevanceHint,
                    RelevanceScore: meetingLocation.RelevanceScore,
                    BuildingDisplayName: meetingLocation.MeetingLocation.BuildingDisplayName,
                    Availability: availability,
                    BusinessAddressesArray: [address],
                    NumberOfAvailableTimeSlots: meetingLocation.NumberOfFreeOccurrences,
                    TotalNumberOfTimeSlots: findMeetingLocationsResponse.TotalOccurrences,
                    IsPartialAvailability:
                        findMeetingLocationsResponse.IsRecurrenceExpansionPartial,
                } as LocationPersonaType);
            });
        }
    }
    return personas;
}

/*
 * Gets Location Source
 * 25154: LAS - Rationalize LocationType and LocationSource values to align with EVent LocationSource
 */
function getOwaLocationSource(location: MeetingLocation): LocationSourceType {
    if (location.EntityType == 'ConferenceRoom') {
        return 'Resource';
    } else if (location.LocationSource == 'Bing') {
        return 'LocationServices';
    } else {
        return 'Device';
    }
}
